"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotifyClient = void 0;
const BaseClient_1 = require("../BaseClient");
class NotifyClient extends BaseClient_1.BaseClient {
    constructor(baseUrl, tokenProvider) {
        super(baseUrl, tokenProvider);
    }
    async getAlertToken() {
        const response = await this.axiosInstance({
            method: 'GET',
            url: '/api/v1/notify/alert-token',
        });
        return response.data;
    }
    async getInboxToken() {
        const response = await this.axiosInstance({
            method: 'GET',
            url: '/api/v1/notify/inbox-token',
        });
        return response.data;
    }
}
exports.NotifyClient = NotifyClient;
